import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EntityOrderedRequestParameters, EntityPagedRequestParameters } from '@bndes/bndes-ux4/bndes-angular-utils';
import { AcompanhamentoDocumentoDepr, periodosAcompanhamentoDocumentoDepr, tiposAcompanhamentoDocumentoDepr } from 'src/app/model/acompanhamento-documento-depr.model';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import Utils from 'src/app/shared/fgi-utils';

@Component({
  selector: 'app-acompanhamento-depr-listagem',
  templateUrl: './acompanhamento-depr-listagem.component.html',
  styleUrls: ['./acompanhamento-depr-listagem.component.scss'],
  standalone: false,
})
export class AcompanhamentoDeprListagemComponent implements OnInit {

    @Input() agentesFinanceiros: AgenteFinanceiro[];
    @Input() acompanhamentos: AcompanhamentoDocumentoDepr[];
    @Input() atributosPaginacao: EntityPagedRequestParameters;
    @Input() ehAgenteFinanceiro: boolean;

    @Output() aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();
    @Output() aoRequererDesativacao: EventEmitter<AcompanhamentoDocumentoDepr> = new EventEmitter<AcompanhamentoDocumentoDepr>();
    private atributosOrdenacao: EntityOrderedRequestParameters;

    ngOnInit(): void {
        this.atributosOrdenacao = {
            atributo: '',
            sentido: 'asc'
        }
    }

    nomeAgenteFinanceiro(cnpj: string) {
        return Utils.nomeAgentePorCNPJ(cnpj, this.agentesFinanceiros);
    }

    nomeTipoDocumento(tipo: string) {
        return tiposAcompanhamentoDocumentoDepr.find(tipoAcopanhamento => tipo === tipoAcopanhamento.id).descricao;
    }

    nomePeriodo(periodo: string) {
      if(periodo != null){
        return periodosAcompanhamentoDocumentoDepr.find(periodoAcompanhamento => periodo === periodoAcompanhamento.id).descricao;
      }
    }

    mudancaPagina(novaPagina: EntityPagedRequestParameters) {
        this.atributosPaginacao = novaPagina;
        this.aoMudarPagina.emit(novaPagina);
    }

    mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
        this.atributosOrdenacao = novaOrdenacao;
        this.pesquisarOrdenacao(this.atributosOrdenacao);
    }

    pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
        this.acompanhamentos = this.acompanhamentos.sort((a, b) => {
            if (ord.sentido == "asc") {
                return Utils.compara(a, b, ord.atributo);
            }
            else {
                return -1 * Utils.compara(a, b, ord.atributo);
            }
        });
    }

}
